/**
 * @desc H5门店反馈 (REFACTOR)
 */

import { RequestConfig, request } from 'umi';

function req(
  data: defs.store.StoreFeedback,
  config: Parameters<typeof request>[1] = {},
) {
  return request<defs.store.HttpResponse>(`/storeapi/api/r/store/feedback`, {
    data,
    method: 'post',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.HttpResponse;
export default req;
